import { Box, type BoxProps } from "@mui/material"
import { type PropsWithChildren, useEffect, useState } from "react"
import { createPortal } from "react-dom"
import { safeMergeSx } from "../../../utils"
import { SUB_HEADER_PORTAL_ID } from "./stickyHeader.const"

/**
 * Portals its children into the sticky header stack: the Stack rendered by
 * HeaderMini, anchored by {@link SUB_HEADER_PORTAL_ID}.
 *
 * That stack is a flex column, so `order` alone drives the vertical position.
 * Ordering is owned by each universe: pass the order from its own conf
 */
export const StickyHeaderSlot = ({
  order = 0,
  slotProps,
  children,
}: PropsWithChildren<{
  order?: number
  slotProps?: { box?: BoxProps }
}>) => {
  const [target, setTarget] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setTarget(document.getElementById(SUB_HEADER_PORTAL_ID))
  }, [])

  if (!target) return null

  return createPortal(
    <Box
      {...slotProps?.box}
      sx={safeMergeSx({ order, flexShrink: 0 }, slotProps?.box?.sx)}
    >
      {children}
    </Box>,
    target,
  )
}
